module.exports = __webpack_public_path__ + "img/club-brugge-kv.e2eea0be.png";